/**
 * "31 answers", in a way that is not wrong in either language.
 *
 * WHY THIS IS NOT A PLURAL RULE. vue-i18n's built-in pluralisation picks between forms
 * separated by `|` using a default rule with at most three branches. English needs two
 * and Arabic needs six (zero, one, two, few, many, other), and registering a CLDR rule
 * for one locale in a message tree this small buys a whole mechanism to get one label
 * right. So the four cases that actually change the WORDS are named — none, one, the
 * Arabic dual, and everything above it — and the caller picks one. `2 answers` and
 * `إجابتان` are both correct; `1 answers` and `٢ إجابة` are the two failures this avoids.
 *
 * Three and above is `MANY`, which since C4 (spec §7 P-7.3) is a six-form Arabic choice like
 * every other count: `useWasloI18n`'s `t` reads the plural from the formatted count, so
 * `٧ إجابات` and `١١ إجابة` are both right.
 */

/** @param {number} count @returns {'NONE'|'ONE'|'TWO'|'MANY'} */
export const countCase = count => {
  if (!Number.isFinite(count) || count <= 0) return 'NONE';
  if (count === 1) return 'ONE';
  if (count === 2) return 'TWO';
  return 'MANY';
};

/**
 * @param {(key: string, params?: object) => string} t The scoped translator.
 * @param {number} count
 * @param {(value: number) => string} format Locale number formatting, from the caller —
 *   an Arabic account writes ٣١, and this helper has no business knowing the locale.
 */
export const answerCountLabel = (t, count, format) =>
  t(`WASLO.ANSWERS.COUNT.${countCase(count)}`, { count: format(count) });

export default answerCountLabel;
